export default (data) => {
  const paidInterestData = data.PAYMENT_DATA.reduce((accum, item, key) => {
    const a = [...accum];
    if (key % data.INTERVAL === 0) a[accum.length] = item.interest;
    return a;
  }, [0]);
  paidInterestData.pop(); 
  // const test = 0;
  // test++;
  // test++;
  const paidPrincipleData = data.PAYMENT_DATA.reduce((accum, item, key) => {
    const a = [...accum];
    if (key % data.INTERVAL === 0) a[accum.length] = item.principle;
    return a;
  }, [0]);
  paidPrincipleData.pop();
  const remainingPrinciple = data.PAYMENT_DATA.reduce((accum, item, key) => {
    const a = [...accum];
    if (key % data.INTERVAL === 0) {
      a[accum.length] = data.PRINCIPLE - data.DOWNPAYMENT - item.principle;
    }
    return a;
  }, []);
  remainingPrinciple.pop();
  remainingPrinciple[remainingPrinciple.length] = 0;
  const labelArray = data.PAYMENT_DATA.reduce((accum, item, key) => {
    const a = [...accum];
    if (key % data.INTERVAL === 0) a[accum.length] = '';// item.date.format('MMM DD. YYYY');
    return a;
  }, ['']);
  labelArray.pop();
  const options = {
    events: [],
    aspectRatio: 1,

    responsive: true,
    legend: {
      display: false,
    },
    elements: {
      line: {
        fill: true,
      },
    },
    plugins: {
      filler: {
        propagate: false,
      },
    },
    scales: {
      yAxes: [{
        gridLines: {
          display: true,
          ticks: {
            display: false,
          },
        },
        width: '500',
        ticks: {
          beginAtZero: true,
          callback(value) {
            return `${value / 100000}k`;
          },
        },
      }],
      xAxes: [{
        gridLines: {
          display: false,
        },
      }],
    },
  };
  return {
    type: 'line',
    data: {

      labels: labelArray,
      datasets: [
        {
          pointRadius: data.POINT_RADIUS,
          borderWidth: 0,
          pointBackgroundColor: 'rgb(55, 149, 133)',
          label: 'Principle',
          data: paidPrincipleData,
          borderColor: 'rgba(98, 197, 180, .4)',
          backgroundColor: 'rgba(98, 197, 180, .4)',
        },
        {

          pointBackgroundColor: 'rgb(82, 100, 122)',
          borderWidth: 0,
          label: 'Interest',
          data: paidInterestData,
          pointRadius: data.POINT_RADIUS,
          borderColor: 'rgba(114, 135, 161, .6)',
          backgroundColor: 'rgba(114, 135, 161, .6)',

        },

        {
          pointBackgroundColor: 'rgb(128, 162, 42)',
          borderWidth: 0,
          pointRadius: data.POINT_RADIUS,
          label: 'Remaining Balance',
          data: remainingPrinciple,
          borderColor: 'rgba(172, 209, 77, .75)',
          backgroundColor: 'rgba(172, 209, 77, .75)',
        },
      ],
    },
    options,
  };
};